import React from "react"

import Layout from "../../components/Layout"
import SEO from "../../components/Seo"
import OurCommitment from "../../components/AboutUs/OurCommitment"
import WhyWeAre from "../../components/AboutUs/WhyWeAre"
import OurHomes from "../../components/AboutUs/OurHomes"

const AboutUs = () => (
  <Layout>
    <SEO title="About Us" />
    <WhyWeAre />
    <OurCommitment />
    <OurHomes />
  </Layout>
)

export default AboutUs
